import Vue from 'vue';

export const SET_DATASET_DATA = 'SET_DATASET_DATA';

export default {
  [SET_DATASET_DATA](state, { datasetName, data }) {
    Vue.set(state, datasetName, data);
  }
};
